/* import __COLOCATED_TEMPLATE__ from './seller-postings-filters.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { dropTask } from 'ember-concurrency';
import { POSTINGS_EXPLORE_FILTER_API_ENUMS } from 'sh-www/constants/routes/postings';

class SellerPostingsFiltersComponent extends Component {
  @tracked filters = {};
  @tracked minimumDayRateFilter =  this.args.minimumDayRateFilter ?? '';
  @tracked filteredLocation = null;

  get filterEnums() {
    return POSTINGS_EXPLORE_FILTER_API_ENUMS;
  }

  @action
  toggleFilter(filter) {
    const value = this.filters[filter];
    this.filters = {
      ...this.filters,
      [filter]: value ? undefined : !value,
    };
  }

  @dropTask
  *updateFilter(filterName, value) {
    this[filterName] = value;

    switch (filterName) {
      case POSTINGS_EXPLORE_FILTER_API_ENUMS.PLACE_ID:
        this.args.placeIdFilterChanged(value);
        break;

      case POSTINGS_EXPLORE_FILTER_API_ENUMS.MIN_DAY_RATE:
        this.minimumDayRateFilter = value;
        this.args.minimumDayRateFilterChanged(value);
        break;

      case POSTINGS_EXPLORE_FILTER_API_ENUMS.IS_REMOTE:
        this.args.remoteFilterChanged(!value);
        break;

      case POSTINGS_EXPLORE_FILTER_API_ENUMS.NO_FEES:
        this.args.hasNoFeesFilterChanged(!value);
        break;

      case POSTINGS_EXPLORE_FILTER_API_ENUMS.COVERS_EXPENSES:
        this.args.coversExpensesFilterChanged(!value);
        break;

      case POSTINGS_EXPLORE_FILTER_API_ENUMS.SERVICE_MATCH:
        this.args.userOfferedServicesFilterChanged(!value);
        break;
    }
  }
}

export default SellerPostingsFiltersComponent;
